const m = angular.module('sentryModule', []);

m.factory('sentry', require('./sentry.js'));

module.exports = 'sentryModule';